import { FC } from "react";

import BasicWidget, {
  BasicWidgetProps,
} from "src/dynamic-view-renderer/Widgets/BasicWidget/BasicWidget.tsx";
import { useClientSchemaQuery } from "src/graphql/anti-fraud/queries/cases/GetCaseSchemasQuery.ts";
import { useT } from "src/internationalization";

import WidgetContainer from "../WidgetContainer";

const WidgetCaseSchema: FC<Omit<BasicWidgetProps, "itemSchema">> = ({
  widgetConfig,
  rowConfiguration,
  ...props
}) => {
  const t = useT();
  const { data: caseSchema, error: caseSchemaError } = useClientSchemaQuery();

  if (caseSchemaError) {
    return (
      <WidgetContainer widgetConfig={widgetConfig} rowConfiguration={rowConfiguration}>
        <div className="text-supportError mb-4">{t("general.clientSchemaError")}</div>
      </WidgetContainer>
    );
  }

  return (
    <BasicWidget
      {...props}
      itemSchema={caseSchema}
      widgetConfig={widgetConfig}
      rowConfiguration={rowConfiguration}
    />
  );
};

export default WidgetCaseSchema;
